import React from 'react';

class OperatorPicker extends React.Component {
    constructor(props) {
        super(props);


        this.defaultState = this.defaultState.bind(this);
        this.showSelector = this.showSelector.bind(this);
        this.swapEdit = this.swapEdit.bind(this);
        this.defaultState(props);
        this.dropdownItem = this.dropdownItem.bind(this);
        this.displayValue = this.displayValue.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.available = {
            '<=':'is less or equal to',
            '>=':'is greater or equal to',
            '==':'is equal to',
            '%%':'contains',
            '!=':'is not equal to',
        };

    }

    swapEdit(e) {
        this.setState({'isEditing':!this.state.isEditing});
    }

    defaultState(props) {
        this.state = {
            'isEditing':false
        };
    }

    displayValue(value) {
        return this.available[value];
    }

    componentWillMount() {
        /*if(this.props.rule.operator == '' || typeof this.available[this.props.rule.value] == 'undefined' ) {
            this.props.setGlobalTypeState('rules',this.props.rule.id,{'value':4});
        }*/
    }

    handleOnChange(i) {
        this.swapEdit();
        this.props.setGlobalTypeState('rules',this.props.rule.id,{'operator':i});
    }

    dropdownItem(i,value) {
        if(typeof this.props.include === 'undefined') {
            return <a key={i} onClick={(e) => {e.stopPropagation(); this.handleOnChange(i)}} className="dropdown-item" href="javascript:void(0)" role="menuitem" tabIndex="-1">{value}</a>
        }

        if(this.props.include.includes(i)) {
            return <a key={i} onClick={(e) => {e.stopPropagation(); this.handleOnChange(i)}} className="dropdown-item" href="javascript:void(0)" role="menuitem" tabIndex="-1">{value}</a>
        }

        return null;
    }

    showSelector() {

        if(!this.state.isEditing) {
            return <span onClick={(e) => {e.stopPropagation();this.swapEdit(e);} } className="selected-rule">{this.displayValue(this.props.rule.operator)}</span>;
        }

        return (
            <div className="dropdown open">
                <button type="button" className="btn btn-dark dropdown-toggle btn-sm" aria-expanded="true" data-toggle="dropdown">
                    {this.displayValue(this.props.rule.operator)}
                    <span className="caret"></span>
                </button>
                <div className="dropdown-menu">
                    {
                        Object.keys(this.available).map((i) => {
                            return this.dropdownItem(i,this.available[i]);
                        })
                    }
                </div>
            </div>
        );




    }

    render() {

        return (
            <span>{this.showSelector()} &nbsp;</span>
        );
    }


}

export default OperatorPicker;




// WEBPACK FOOTER //
// ./components/builder/Operator.js